export { register } from './Registry';
export {
  getHeight,
  getWidth,
  registryReducerKey,
  registryReducer
} from './state';
